import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/dashboard`;
const millingPath = `${BASE_API_URL}/milling`;

// ?searchDate=2021-11-22
export function fetchSchedule(payload: object | any) {
  return axs({ url: `${basePath}/schedule`, method: 'get', params: payload });
}

// ?searchDate=2021-11-22&isRequest=1&projectDuration=1W&stage=0%1%2&partnerGroupIdx=
export function fetchProjectGraph(payload: {
  searchDate: string;
  isRequest: number;
  projectDuration: string;
  stage: string;
  partnerGroupIdx: number;
}) {
  return axs({ url: `${basePath}/project/graph`, method: 'get', params: payload });
}

// ?currency='KRW'&duration='1Y'&partnerships=1%20%30
export function fetchSalesGraph(payload: {
  currency: string;
  duration: string;
  partnerGroupIdx: string;
}) {
  return axs({ url: `${basePath}/sales`, method: 'get', params: payload });
}

export function fetchUpdatedProjects(payload: { page: number }) {
  return axs({ url: `${basePath}/updatedproject`, method: 'get', params: payload });
}

export function fetchProductData() {
  return axs({ url: `${basePath}/product/data`, method: 'get' });
}

export function fetchLayout() {
  return axs({ url: `${basePath}/layout`, method: 'get' });
}

export function editLayout(payload: { layout: string }) {
  return axs({ url: `${basePath}/layout`, method: 'post', data: payload });
}

export function fetchMillingNotification(payload: { page: number }) {
  return axs({ url: `${millingPath}/msg`, method: 'get', params: payload });
}

export function fetchScanPatients() {
  return axs({ url: `${basePath}/waitingscan`, method: 'get' });
}

export function fetchLatestProjects() {
  return axs({ url: `${basePath}/project/latest`, method: 'get' });
}
